<button
  tuiButton
  [appearance]="'lp-icon-block'"
  [size]="'s'"
  [iconStart]="'@tui.circle-plus'"
  [routerLink]="'./product-request'"
>
  {{ 'components.lpProductRequest.buttons.productRequestLink' | translate }}
</button>
